// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceCloudBoltSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 6.535V6.5a6.5 6.5 0 0 1 12.512-2.476 5 5 0 1 1 .888 9.96V14H5.85v-.003A4 4 0 0 1 4 6.535zM13.424 15c.3 0 .502.315.381.596l-1.012 2.362h.79c.338 0 .535.39.34.671l-2.906 4.19c-.242.35-.781.156-.755-.272l.145-2.37h-.99a.424.424 0 0 1-.4-.545l1.235-4.326a.418.418 0 0 1 .4-.306z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceCloudBoltSolid;
